import type { CatalogueConfig } from '../catalogue/catalogue.types';
import type { Scope } from './models/scope.model';
import { ScopeStoreService } from './services/scope-store.service';

export const SCOPE_CATALOGUE: CatalogueConfig<Scope> = {
  label: 'Scope',
  plural: 'Scopes',
  routeBase: '/scopes',
  storeToken: ScopeStoreService,
  placeholderIcon: '@tui.crosshair',
  badges: (s) => [s.specification ?? ''],
};
